function initImageCardSlider() {
  $(".image-card [data-slider]").each(function () {
    if ($(this).data('flickity')) {
      $(this).flickity('destroy');
    }

    $(this).flickity({
      cellAlign: "left",
      autoPlay: false,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true
    });
  });
}

$(document).ready(initImageCardSlider);
$(window).on("resize", initImageCardSlider);
